(function($) {
  let Selfie = {
    step: 0,
    needs_face: false,
    needs_deco: false,
    messages: {
      success: 'Information Updated Successfully!',
      stepFail1: 'Please select at least one concern.',
      stepFail2: 'Please select an image to upload.',
      stepFail2Size: 'The size of your photo must be less than 10MB.',
      stepFail2Type: 'The photo must be of type <em>jpg</em>, <em>jpeg</em>, or <em>png</em>.',
      submitFail: 'We are unable to submit your entry at this time. Please try again or contact us for assistance'
    },
    data: [],
    files: {face: null, deco: null},
    init: function () {
      this.data['concerns'] = [];
      this.bindEvents();
      this.updateFootnotes(this.step);
    },
    bindEvents: function () {
      var self = this;

      $('.step-controls a').on('click', function(e) {
        e.preventDefault();
        if ($(this).attr('href') === '#prev') {
          self.prevStep();
        }
        if ($(this).attr('href') === '#next') {
          self.nextStep();
        }
      });

      //! STEP 1
      $('#your-concerns input[type=checkbox]').on('click', function (e) {
        if ($(this).hasClass('active')) {
          $(this).removeClass('active');
          if (self.data['concerns'].includes($(this).val())) {
            var index = self.data['concerns'].indexOf($(this).val());
            if (index !== -1) {
              self.data['concerns'].splice(index, 1);
            }
          }
        }
        else {
          $(this).addClass('active');
          if(!self.data['concerns'].includes($(this).val())) {
            self.data['concerns'].push($(this).val());
          }
        }
      });

      //! STEP 2
      self.updatePhoto('deco');
      self.updatePhoto('face');

    },
    prevStep: function() {
      var self = this;

      switch(self.step) {
        case 3:
          // go to concerns if you don't need a face, or go to face.
          self.step = !self.needs_face ? 1 : 2;
          break;
        case 4:
          // go to face if you don't need a chest.
          self.step = !self.needs_deco ? 2 : 3;
          break;
        default:
          self.step--;
          break;
      }

      self.updateProgress();
    },
    nextStep: function() {
      var self = this;

      switch(self.step) {
        case 0:
          // no processing here so always returns 'next'
          self.step++;
          self.updateProgress();
          break;
        case 1:
          self.processConcerns();
          break;
        case 2:
          self.processFace();
          break;
        case 3:
          self.processDeco();
          break;
        case 4:
          self.processUser();
          break;
        default:
          break;
      }
    },
    hideErrors: function() {
      $('#selfie-messages').modal('hide').find('.message').empty();
    },
    showErrors: function(msg) {
      $('#selfie-messages').find('.message').html(msg);
      $('#selfie-messages').modal('show');
      window.scrollTo(0, 0);
    },
    updateProgress: function() {
      var self = this;

      // reset
      $('#selfie-form .step-panel').removeClass('active');
      self.hideErrors();

      // set active step
      $('#selfie-form #step-' + self.step).addClass('active');

      setTimeout(function() {
        $('html, body').animate({
          scrollTop: $('#top').offset().top - 45
        }, 500);
        self.updateFootnotes();
      }, 300);
    },
    updateFootnotes: function() {
      // only reason we're doing this is the footnotes sit
      // BELOW a callout we don't want to reuse
      var self = this;

      // clear out previous
      $('#step-footnotes-wrapper').hide().empty();

      var step_el = $('#selfie-form #step-' + self.step);

      if (step_el.hasClass('active')) {
        var footnotes = step_el.find('.step-footnotes');
        if ($(footnotes).length > 0) {
          $('#step-footnotes-wrapper').append(footnotes.html()).show();
        }
      }
    },
    updatePhoto: function(concern) {
      var self = this;

      var target = '';
      $('#your-photo-' + concern).click(function() {
        $('#file-upload-' + concern).click();
      });

      $('#file-upload-' + concern).on('change', function(e) {
        self.hideErrors();
        // check file size, return error if over 10MB
        if (this.files[0].size > 10485760) {
          self.showErrors(self.messages.stepFail2Size);
          return;
        }

        // check file type, return error if not jpg, jpeg, or png, case insensitive
        var filetype = (this.files[0].type);
        var goodfile = (filetype == 'image/jpeg' || filetype == 'image/png') ? true : false;
        if (!goodfile) {
          self.showErrors(self.messages.stepFail2Type);
          return;
        }

        var placeHolderPic = $('#your-photo-' + concern);
        self.files[concern] = this.files[0];
        var reader = new FileReader();
        reader.onload = (function (placeholder) {
          return function (e) {
            $(placeholder).css('background-image', 'url(' + e.target.result + ')');
          };
        })(placeHolderPic);
        reader.readAsDataURL(this.files[0]);
      });
    },
    processConcerns: function() {
      var self = this;

      if (self.data['concerns'].length === 0) {
        self.showErrors(self.messages.stepFail1);
        return;
      }

      var arr = ['brow', 'chin', 'neck'];
      self.needs_face = arr.some(function(el) {
        return self.data['concerns'].includes(el);
      });
      arr = ['deco'];
      self.needs_deco = arr.some(function(el) {
        return self.data['concerns'].includes(el);
      });

      // go to deco if you don't need a face, or go to face.
      self.step = (!self.needs_face && self.needs_deco) ? 3 : 2;

      self.updateProgress();
    },
    processFace: function() {
      var self = this;

      if (self.needs_face) {
        if (self.files.face === null) {
          self.showErrors(self.messages.stepFail2);
          return;
        }
      }

      // go to deco or skip and go to userinfo
      self.step = (self.needs_deco) ? 3 : 4;
      self.updateProgress();
    },
    processDeco: function() {
      var self = this;

      if (self.needs_deco) {
        if (self.files.deco === null) {
          self.showErrors(self.messages.stepFail2);
          return;
        }
      }

      self.step++;
      self.updateProgress();
    },
    processUser: function() {
      var self = this;

      self.data['userData'] = self.getUserInfo();
      if (!self.data['userData'].success) {
        var error_message = '<ul class="unstyled ml-2">';
        $.each(self.data['userData'].values, function (k, v) {
          error_message += '<li>' + v + '</li>';
        });
        error_message += '</ul>';
        self.showErrors(error_message);
        return;
      }

      // reset files obj based on what we need or don't need
      if (!self.needs_face) self.files.face = null;
      if (!self.needs_deco) self.files.deco = null;

      $('#selfie-form').submit();

      self.step++;
      self.updateProgress();
    },
    getUserInfo: function () {
      var error_msgs = [],
          required_fields = 0,
          values = {},
          return_values = [];

      values.fname = ($('#uss-first-name').val()) ? $('#uss-first-name').val() : required_fields++;
      values.lname = ($('#uss-last-name').val()) ? $('#uss-last-name').val() : required_fields++;
      values.email = ($('#uss-email').val()) ? $('#uss-email').val() : required_fields++;
      var pattern = /[^\s@]+@[^\s@]+\.[^\s@]+/;
      if (!pattern.test(values.email)) {
        error_msgs.push('Email address not in valid format');
      }
      values.zip = ($('#uss-zip').val()) ? $('#uss-zip').val() : required_fields++;
      values.appointment = ($('input[name="uss-appointment"]').is(':checked')) ? $('input[name="uss-appointment"]').is(':checked') : required_fields++;

      if (required_fields > 0) {
        error_msgs.push('One or more fields were left empty.');
      }

      if ($('input.agreement').not(':checked').length > 0) {
        error_msgs.push('You need to check all the boxes to indicate that you have reviewed, understood and agree to all the terms.');
      }

      if (error_msgs.length > 0) {
        return_values['success'] = false;
        return_values['values'] = error_msgs;
        return return_values;
      }
      return_values['success'] = true;
      return_values['values'] = values;
      return return_values;
    }
  };
  $(document).ready(function () {
    if (typeof Selfie !== 'undefined') {
      Selfie.init();
    }
  });
})(jQuery);


